const t = "styles-module__stripe_button___RGL-S", s = {
  stripe_button: t
};
export {
  s as default,
  t as stripe_button
};
